<template>
  <button
    class="bg-brand-600 rounded w-full relative h-10 p-2 text-white hover:bg-brand-700 disabled:opacity-50 disabled:bg-brand-600"
    :disabled="isLoading || disabled"
    data-testid="email_save_button"
  >
    <LayupSpinner v-if="isLoading" />
    <span v-else>{{ label }}</span>
  </button>
</template>

<script lang="ts" setup>
import LayupSpinner from './LayupSpinner.vue';

defineProps<{
  isLoading: boolean;
  label: string;
  disabled?: boolean;
}>();
</script>
